module.exports = __webpack_public_path__ + "media/images/cours de yoga-687660dc09d212b8883dcf11d3746641.svg";